import React from "react";

const SieraDashboard = ({ activeDashboard }) => {
  if (!activeDashboard?.layout?.url) return null;

  return (
    <div style={{ width: "100%", height: "100vh", paddingTop: "71px" }}>
      <iframe
        src={activeDashboard.layout.url}
        title="Siera Dashboard"
        style={{ width: "100%", height: "100%", border: "none" }}
      />
    </div>
  );
};

export default SieraDashboard;
